import { render, staticRenderFns } from "./BlockInfoProduct.vue?vue&type=template&id=6dfdf37a&"
import script from "./BlockInfoProduct.vue?vue&type=script&lang=js&"
export * from "./BlockInfoProduct.vue?vue&type=script&lang=js&"
import style0 from "./BlockInfoProduct.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports